import React from 'react';
import { SkeletonBlock, SkeletonStack } from '../skeleton';

export const QueryDialogResultsLoader = () => (
    <SkeletonStack aria-hidden='true' $gap='10px'>
        {Array.from({ length: 5 }).map((_, idx) => (
            <SkeletonBlock key={idx} $height='37px' $radius='10px' />
        ))}
    </SkeletonStack>
);
